module.exports = __webpack_public_path__ + "img/xiao-rain.06876a29.png";